import React, { useState } from 'react';

import { ConstantInputComponent } from 'main/components/ContactInputComponent';
import { SEO } from 'main/components';

export const SubscribeContact: React.FC = () => {
  const [selectedElement, setSelectedElement] = useState<null | string>(null);
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');

  const [errors, setErrors] = useState<Record<string, string> | null>(null);
  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<{
    success: boolean;
    message: string;
  } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const newErrors: Record<string, string> = {};

    // Only email is required now
    if (!email) newErrors.email = 'Email field is required';

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      newErrors.email = 'Value is not a valid email format';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    setLoading(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(
        'https://connect.mailerlite.com/api/subscribers',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${process.env.REACT_APP_MAILER_LITE_KEY}`,
          },
          body: JSON.stringify({
            email: email,
            fields: {
              name: name,
              last_name: lastName,
              company: company,
            },
          }),
        },
      );

      if (!response.ok) {
        let errorMessage = 'Something went wrong. Please try again later.';
        try {
          const errorData = await response.json();
          if (errorData && errorData.message) {
            errorMessage = errorData.message;
          }
        } catch (parseError) {
          console.error('Error parsing error response:', parseError);
          // Keep the default error message if parsing fails
        }
        throw new Error(
          `MailerLite error: ${response.status} - ${errorMessage}`,
        );
      }

      setSubmitStatus({
        success: true,
        message: 'Thank you for subscribing!',
      });

      // Reset form
      setName('');
      setLastName('');
      setEmail('');
      setCompany('');
      setErrors(null);
    } catch (error) {
      console.error('Submission error:', error);
      let errorMessage = 'Something went wrong. Please try again later.';
      if (error instanceof Error) {
        errorMessage = 'Sent Email is incorrect';
      }
      setSubmitStatus({
        success: false,
        message: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEO
        seoTitle="Subscription - Subscribe to Email List - Orqa"
        seoDescription="Subscription form fot he latest updates"
        noindex={true}
      />
      <section
        className="page contact--responsive"
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <div className="wrapper wrapper--narrow" style={{ margin: 'auto' }}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '25px',
            }}
          >
            <img
              style={{ width: '130px', alignSelf: 'center' }}
              src={require('main/assets/images/defense/Logo-black.png')}
              alt="Company logo"
              className="contact-page-logo"
            />
          </div>
          <div
            style={{
              maxWidth: '600px',
              width: '100%',
              textAlign: 'center',
              margin: '0px auto',
            }}
          >
            <h2
              style={{
                maxWidth: '600px',
                fontSize: 'calc(24px + 8 * ((100vw - 320px) / 1000))',
                margin: '0 0 8px 0',
                color: '#FF2238',
                lineHeight: '1.25',
                paddingBottom: '30px',
              }}
            >
              SUBSCRIPTION
            </h2>

            {submitStatus && (
              <div
                style={{
                  textAlign: 'left',
                  marginBottom: '15px',
                  padding: '10px',
                  backgroundColor: submitStatus.success ? '#e6ffed' : '#ffebee',
                  border: `1px solid ${
                    submitStatus.success ? '#a3d8b1' : '#ffcdd2'
                  }`,
                  borderRadius: '4px',
                }}
              >
                <p
                  style={{
                    fontSize: '14px',
                    color: submitStatus.success
                      ? '#07bc0c'
                      : 'rgb(255, 34, 56)',
                    margin: 0,
                  }}
                >
                  {submitStatus.message}
                </p>
              </div>
            )}

            <form
              id="asda-form"
              style={{
                maxWidth: '600px',
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                gap: '25px',
              }}
              onSubmit={handleSubmit}
            >
              <div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                  }}
                >
                  <ConstantInputComponent
                    setter={setName}
                    setSelectedElement={setSelectedElement}
                    selectedElement={selectedElement}
                    name={'Name'}
                    errors={errors}
                    getter={name}
                  />
                  <ConstantInputComponent
                    setSelectedElement={setSelectedElement}
                    selectedElement={selectedElement}
                    name={'Last Name'}
                    setter={setLastName}
                    errors={errors}
                    getter={lastName}
                  />
                  <ConstantInputComponent
                    setSelectedElement={setSelectedElement}
                    selectedElement={selectedElement}
                    name={'Email'}
                    setter={setEmail}
                    errors={errors}
                    getter={email}
                    required
                  />
                  <ConstantInputComponent
                    setSelectedElement={setSelectedElement}
                    selectedElement={selectedElement}
                    name={'Company'}
                    setter={setCompany}
                    errors={errors}
                    getter={company}
                  />
                </div>
              </div>
              <div
                style={{
                  maxWidth: '600px',
                  width: '100%',
                }}
              >
                <button
                  type="submit"
                  disabled={loading}
                  className="asda__submit-button"
                  style={{ width: '100%' }}
                >
                  {loading ? (
                    <div className="asda__button-spinner--wrapper">
                      <div className="asda__button-spinner" />
                    </div>
                  ) : (
                    <p>SEND</p>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};
